var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visitGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#E5DECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#5F7A61"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 40,
    height: 12,
    fill: "url(#visitGradient)",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 48,
    width: 32,
    height: 4,
    fill: "#1C1917",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 12,
    height: 28,
    fill: "#E5DECF",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 1.5,
    fill: "#5F7A61"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 8,
    height: 8,
    fill: "none",
    stroke: "#1C1917",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 8,
    height: 8,
    fill: "none",
    stroke: "#1C1917",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 8,
    height: 20,
    fill: "#F5F0E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 8,
    height: 20,
    fill: "#F5F0E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 4,
    height: 6,
    fill: "#FFFFFF",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 4,
    height: 6,
    fill: "#FFFFFF",
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 8,
    height: 4,
    fill: "#5F7A61",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 42,
    r: 3,
    fill: "#5F7A61",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 42,
    r: 3,
    fill: "#5F7A61",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitIcon);
export default __webpack_public_path__ + "static/media/visit-icon.31673e796c3dec15572ba457fe2728e3.svg";
export { ForwardRef as ReactComponent };